"use strict";

require("./_yotpo-stars-grid");